(function () {
  angular.module("akitabox.serviceRequest.detail", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.router",
    "akitabox.core.services.request",
    "akitabox.core.services.recentActivity",
    "akitabox.core.services.shadow",
    "akitabox.core.toast",
    "akitabox.ui.dialogs.request.deny",
    "akitabox.ui.dialogs.request.delete",
    "akitabox.ui.dialogs.request.reopen",
    "akitabox.ui.dialogs.message.create",
    "akitabox.ui.dialogs.displayText",
  ]);
})();
